import {
  FETCH_SUPERVISOR_WISE_OT_REQUEST,
  FETCH_SUPERVISOR_WISE_OT_SUCCESS,
  FETCH_SUPERVISOR_WISE_OT_FAILURE,
  FETCH_OT_EMP_NOTLEFT_REQUEST,
  FETCH_OT_EMP_NOTLEFT_SUCCESS,
  FETCH_OT_EMP_NOTLEFT_FAILURE,
  FETCH_LOCATION_NOT_OFF_REQUEST,
  FETCH_LOCATION_NOT_OFF_SUCCESS,
  FETCH_LOCATION_NOT_OFF_FAILURE,
} from "../constants/OTAllocatedConstants";

import OTAllocatedService from "../service/OTAllocatedService";

export const fetchSupWiseOT = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }
  try {
    dispatch({ type: FETCH_SUPERVISOR_WISE_OT_REQUEST });
    const data = await OTAllocatedService.getSupWiseOT(date);
    dispatch({ type: FETCH_SUPERVISOR_WISE_OT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_SUPERVISOR_WISE_OT_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchLocationNotOff = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }
  try {
    dispatch({ type: FETCH_LOCATION_NOT_OFF_REQUEST });
    const data = await OTAllocatedService.getLocationNotOff(date);
    dispatch({ type: FETCH_LOCATION_NOT_OFF_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATION_NOT_OFF_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchOTEmpNotLeft = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }
  try {
    dispatch({ type: FETCH_OT_EMP_NOTLEFT_REQUEST });
    const data = await OTAllocatedService.getOTEmpNotLeft(date);
    dispatch({ type: FETCH_OT_EMP_NOTLEFT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_OT_EMP_NOTLEFT_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
